export default "__VITE_ASSET__umnCJYpc__"